"use strict";

import Feature from "ol/Feature";
import Translate from "ol/interaction/Translate";
import Collection from 'ol/Collection';
import * as olExtent from 'ol/extent';
import PointerInteraction from 'ol/interaction/Pointer';
import WKT from "ol/format/WKT";
import LineString from "ol/geom/LineString";
import {Style, Fill, Stroke} from "ol/style";
import jQuery from 'jquery';

/**
 *
 * @param {Object} options Aufrufoptionen
 */
gc.gis.module.GCOverview.OLMap = function( options )
{
	gc.gis.GCWrappable.call( this );

	gc.gis.assert.isSet( options );
	this.module = options.module;
	this.__initMap();
};
gc.gis.module.GCOverview.OLMap.prototype = Object.create( gc.gis.GCWrappable.prototype );

/**
 */
gc.gis.module.GCOverview.OLMap.prototype.__initMap = function()
{
	var self = this;

	this.__ol_map = this.module._overview_map.getMap();
	this.__gc_viewport_layer = new gc.gis.layer.OLTrackingLayer(this.__ol_map); // Wrapper nutzen, und dann mit OL-Instanzen weiterarbeiten

	this.__viewport_layer = this.__gc_viewport_layer.getImpl();
	this.__viewport_layer.setStyle(this.__getStyle());
	this.__viewport_source = this.__viewport_layer.getSource();

	this.__viewport_feature_box = new Feature();
	this.__viewport_feature_line_h = new Feature();
	this.__viewport_feature_line_v = new Feature();

	this.__viewport_source.addFeature( this.__viewport_feature_line_h );
	this.__viewport_source.addFeature( this.__viewport_feature_line_v );
	this.__viewport_source.addFeature( this.__viewport_feature_box );

	this.__ol_map.addTrackingLayer(this.__gc_viewport_layer);

	// Box-Drag
	this.__interaction_move = new Translate({
		features: new Collection([self.__viewport_feature_box])
	});
	this.__interaction_move.on('translatestart', function( evt ) {
		self.__drag_box_active = true;
	});
	this.__interaction_move.on('translateend', function( evt ) {
		self.__drag_box_active = false;
		// Position vom Mittelpunkt der gedraggten Box nehmen
		self.module._reference_map.setViewport({
			position: olExtent.getCenter(
				self.__viewport_feature_box.getGeometry().getExtent()
			)
		});
	});

	this.__interaction_pointer = new PointerInteraction({
		handleDownEvent: function( evt ) {
			return !self.__drag_box_active;
		},
		handleUpEvent: function( evt ) {
			if( !self.__drag_box_active )
			{
				// Position vom Klick-Event nehmen
				self.module._reference_map.setViewport({
					position: evt.coordinate
				});
			}
			return false;
		}
	});

	this.__ol_map.getImpl().getInteractions().clear();
	this.__ol_map.getImpl().getInteractions().push( this.__interaction_pointer );
	this.__ol_map.getImpl().getInteractions().push( this.__interaction_move );	// nach pointer, da sonst mousedown "überschrieben" wird

	this.__ol_map.getImpl().updateSize();
};

/**
 *
 */
gc.gis.module.GCOverview.OLMap.prototype.getElement = function()
{
	return jQuery( this.__ol_map.getTargetElement() );
};

/**
 *
 */
gc.gis.module.GCOverview.OLMap.prototype._updateViewport = function()
{
	this.__updateViewportBox();
	this.__updateCrosshair();
};

/**
 *
 */
gc.gis.module.GCOverview.OLMap.prototype.__updateViewportBox = function()
{
	// Viewport-Box
	var viewport = this.module._reference_map.getViewport();
	if (viewport && viewport.geometry) {
		var format = new WKT();
		var geom = format.readGeometry(viewport.geometry);

		this.__viewport_feature_box.setGeometry(geom);
	}
};

/**
 *
 */
gc.gis.module.GCOverview.OLMap.prototype.__updateCrosshair = function()
{
	// Center crosshair
	var geom_h = this.__viewport_feature_line_h.getGeometry();
	var geom_v = this.__viewport_feature_line_v.getGeometry();
	if( !geom_h )
	{
		geom_h = new LineString([]);
		geom_v = new LineString([]);
	}

	var ctr_px = this.__ol_map.worldToPixel( this.module._reference_map.getCenter() );
	if( ctr_px )
	{
		var t = this.__ol_map.pixelToWorld( [ctr_px[0], ctr_px[1]-10] );
		var r = this.__ol_map.pixelToWorld( [ctr_px[0]+10, ctr_px[1]] );
		var b = this.__ol_map.pixelToWorld( [ctr_px[0], ctr_px[1]+10] );
		var l = this.__ol_map.pixelToWorld( [ctr_px[0]-10, ctr_px[1]] );
		geom_h.setCoordinates( [l,r] );
		geom_v.setCoordinates( [t,b] );
		this.__viewport_feature_line_h.setGeometry( geom_h );
		this.__viewport_feature_line_v.setGeometry( geom_v );
	}
};

/**
 *
 */
gc.gis.module.GCOverview.OLMap.prototype._updateProjection = function()
{
	this.__ol_map.setProjection( this.module._reference_map.getProjection() );
};

gc.gis.module.GCOverview.OLMap.prototype._addLayer = function()
{
	
};

/**
 *
 */
gc.gis.module.GCOverview.OLMap.prototype.__getStyle = function()
{
	var stroke = new Stroke({
		color:    '#f00',
		width:    2
	});
	var fill = new Fill({
		color: 'rgba(255,0,0,0.25)'
	});

	return function( resolution ) {
		return [new Style({
			stroke: stroke
			//fill:   fill
		})];
	};
};

